import { getLoggedUserInfo } from "../basetool/methods"
import { WtLoginKey } from "../constants/loginKeys"
import { Mixpanel } from "../third-party/Mixpanel"

export const LoginValidate = () => {
  const userId = getLoggedUserInfo(WtLoginKey.userId)
  const userEmail = getLoggedUserInfo(WtLoginKey.userEmail)

  const bId = getLoggedUserInfo(WtLoginKey.businessId)
  const userRole = getLoggedUserInfo(WtLoginKey.userRole)

  const userAuthToken = getLoggedUserInfo(WtLoginKey.authToken)

  if (userId && userEmail && bId && userRole && userAuthToken) {
    return true
  } else {
    return false
  }
}

export const Logout = () => {
  Mixpanel.reset()
  localStorage.clear()
  window.location.href = "/login"
}
